import "./Topbar.css";

export default function Topbar({ title, actions }) {
  return (
    <header className="topbar">
      <h1 className="topbar-title">{title}</h1>
      <div className="topbar-actions">{actions}</div>
    </header>
  );
}
